import styled from 'styled-components';

export const Container = styled.section`
  width: 97%;
  margin: 1rem auto 0 auto;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 0;
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
  }

  & .ant-tabs.ant-tabs-left {
    & .ant-tabs-tab {
      padding: 0.5rem 3rem 0.5rem 1rem;
    }

    & .ant-tabs-tab-active {
      background-color: ${({ theme }) => theme.colors.waterBlue};
      animation: backColorAnimation 0.5s linear;
      @keyframes backColorAnimation {
        from {
          background-color: ${({ theme }) => theme.colors.white};
        }
        to {
          background-color: ${({ theme }) => theme.colors.waterBlue};
        }
      }
    }
  }
`;

export const InnerContainer = styled.div`
  display: flex;
`;

export const NotificationsContainer = styled.div`
  width: 100%;
  margin: 1em;
`;

export const Subtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 60% 40%;
  margin-top: 2em;
  margin-bottom: 1em;
`;
